angular.module('qkr').directive('modalDialogResize', [function() {
    return {
        restrict: 'AC',
        link(scope, element) {
            const modal = element.parent().parent();
            const draggableStr = 'draggableModal';
            const header = $('.modal-header', modal);
            const content = $('.modal-content', modal);

            header.on('mousedown', (mouseDownEvent) => {
                const modalDialog = modal;
                const offset = header.offset();

                // move the modal on drag of the header
                modalDialog.addClass(draggableStr).parents().on('mousemove', (mouseMoveEvent) => {
                    $('.' + draggableStr, modalDialog.parents()).offset({
                        top: mouseMoveEvent.pageY - (mouseDownEvent.pageY - offset.top),
                        left: mouseMoveEvent.pageX - (mouseDownEvent.pageX - offset.left)
                    });
                }).on('mouseup', () => {
                    modalDialog.removeClass(draggableStr);
                });
            });

            // add the resize handle to modal
            content.prepend('<span class="resize-handle"><i class="fa fa-expand"></i></span>');
            const handle = $('.resize-handle', content);

            handle.on('mousedown', () => {
                event.preventDefault ? event.preventDefault() : (event.returnValue = false);
                // start positions and dimensions
                const elem = modal[0];
                const cbMove = mouseMoveEvent.bind(null, event.clientX,
                    event.clientY, elem.clientWidth, elem.clientHeight);

                // add listeners for mousemove and mouseup
                angular.element(document).on('mousemove', cbMove);
                angular.element(document).on('mouseup', mouseUpEvent);
            });

            function mouseMoveEvent(startX, startY, startWidth, startHeight) {
                // set the modal body to have height auto
                $('.modal-body', modal).css({height: 'auto'});
                // resize the modal
                modal.css({
                    width: (startWidth + event.clientX - startX) + 'px',
                    height: (startHeight + startY - event.clientY) + 'px'
                });
            }

            function mouseUpEvent() {
                // remove the mousemove and mouseup events
                angular.element(document).unbind();
            }
        }
    };
}]);



// WEBPACK FOOTER //
// ./src/directives/resize.modal.js